module.exports = require("dicom-character-set");